import { createFileRoute } from "@tanstack/react-router";
import LocationManager from "@/features/inventory/LocationManager";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute("/settings/inventory/locations")({
  component: () => (
    <RequireCapability cap="inventory:manage">
      <SettingsLocationsPage />
    </RequireCapability>
  ),
});

function SettingsLocationsPage() {
  return (
    <div className="container mx-auto px-4 py-6 flex flex-col grow min-h-0 gap-4">
      <div>
        <h1 className="text-lg font-semibold">Locations</h1>
        <p className="text-sm text-muted-foreground">
          Manage storage and production locations.
        </p>
      </div>
      <LocationManager onClose={() => {}} />
    </div>
  );
}
